const API_BASE_URL = "https://api.flipmycar.fr";

export function getApiBaseUrl() {
  // En développement local, utiliser le proxy de setupProxy.js
  if (process.env.NODE_ENV === "development") {
    return "";
  }
  return API_BASE_URL;
}
